'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FacebookIcon = require('../Icons/FacebookIcon');

var _FacebookIcon2 = _interopRequireDefault(_FacebookIcon);

var _LinkedInIcon = require('../Icons/LinkedInIcon');

var _LinkedInIcon2 = _interopRequireDefault(_LinkedInIcon);

var _reactShare = require('react-share');

var _styled = require('./styled');

var _styled2 = _interopRequireDefault(_styled);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var shareUrl = 'https://finbursa.com';
var windowSize = {
  windowWidth: 750,
  windowHeight: 578
};

var onShareWindowClose = function onShareWindowClose() {
  return true;
};

var SocialMedia = function SocialMedia(_ref) {
  var facebook = _ref.facebook,
      linkedIn = _ref.linkedIn;
  return _react2.default.createElement(_styled2.default.SocialMediaContainer, null, _react2.default.createElement(_reactShare.FacebookShareButton, _extends({}, windowSize, {
    onShareWindowClose: onShareWindowClose,
    style: facebook,
    url: shareUrl,
    size: 24
  }), _react2.default.createElement(_FacebookIcon2.default, {
    style: facebook
  })), _react2.default.createElement(_reactShare.LinkedinShareButton, _extends({}, windowSize, {
    onShareWindowClose: onShareWindowClose,
    style: linkedIn,
    url: shareUrl,
    size: 24
  }), _react2.default.createElement(_LinkedInIcon2.default, {
    style: linkedIn
  })), _react2.default.createElement(_styled2.default.SocialMediaText, null, 'Power the network.', _react2.default.createElement('br', null), 'Share!'));
};

exports.default = SocialMedia;